import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

const query = gql`
  query DepartmentCategories($locale: String, $organisationId: ID!, $schemeType: ID!, $departmentId: ID!) {
    departmentData(locale: $locale, organisationId: $organisationId, schemeType: $schemeType, departmentId: $departmentId) {
      employeeOrganisation {
        id
        scheme {
          id
          department {
            id
            name
            roundel {
              link
              imageUrl
            }
            leftColour
            rightColour
            breadcrumbs {
              label
              link
            }
            landingRoundel {
              imageUrl
              link
            }
            categories {
              name
              roundel {
                imageUrl
                link
              }
            }
          }
        }
      }
    }
  }
`

export const getDepartmentCategoriesQueryKey = getQueryNames(query)[0]
export default query
